/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Meta_TitleInputs */

const en_rd_meta_title = /** @type {(inputs: Rd_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent-readiness score — Bystep`)
};

const id_rd_meta_title = /** @type {(inputs: Rd_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skor kesiapan agent — Bystep`)
};

/**
* | output |
* | --- |
* | "Agent-readiness score — Bystep" |
*
* @param {Rd_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_meta_title = /** @type {((inputs?: Rd_Meta_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Meta_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_meta_title(inputs)
	return en_rd_meta_title(inputs)
});